import { searchFilters } from '@/mocks/searchRadios';

interface FilterChipsProps {
  activeFilters: string[];
  onToggleFilter: (key: string) => void;
}

export default function FilterChips({ activeFilters, onToggleFilter }: FilterChipsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1 no-scrollbar">
      {searchFilters.map((f) => (
        <button
          key={f.key}
          onClick={() => onToggleFilter(f.key)}
          className={`flex items-center gap-1.5 px-3.5 py-1.5 text-xs font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap shrink-0 ${
            activeFilters.includes(f.key)
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
          }`}
        >
          <i className={`${f.icon} text-sm`}></i>
          {f.label}
        </button>
      ))}
    </div>
  );
}